export interface ApInvoiceManufacturerMoveResult {
  results: Array<{ manufacturer_invoice_id: number }>;
  vendor_invoice_id: number | null;
}

export type ApInvoiceManufacturerMoveNavigation =
  | { kind: "vendor-invoice" }
  | { kind: "manufacturer-invoice"; manufacturerInvoiceId: number }
  | { kind: "vendor-invoice-list" };

/** Stay on the vendor invoice when attachments remain. Otherwise open the new manufacturer invoice. */
export function apInvoiceManufacturerMoveNavigation(
  result: ApInvoiceManufacturerMoveResult,
): ApInvoiceManufacturerMoveNavigation {
  if (result.vendor_invoice_id != null) {
    return { kind: "vendor-invoice" };
  }
  const created = result.results[0];
  if (created != null) {
    return { kind: "manufacturer-invoice", manufacturerInvoiceId: created.manufacturer_invoice_id };
  }
  return { kind: "vendor-invoice-list" };
}
